{
  "familyId": "SPR-LEEN-FRANS",
  "questions": [
    {
      "id": "SPR-LEEN-FRANS-001",
      "familyId": "SPR-LEEN-FRANS",
      "module": "SpellingRegel",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_frans",
      "questionType": "multiple_choice",
      "question": "Een taalcoach controleert het werkstuk van een leerling. De leerling heeft geschreven: 'Voor mijn verjaardag kreeg ik een mooi kado.' De taalcoach markeert één woord als fout. Welke verbetering is correct?",
      "context": "De leerling twijfelt: schrijf je het zoals je het hoort, of is er een speciale spelling?",
      "options": ["cadeau (Frans leenwoord, oorspronkelijke spelling behouden)", "kado (je schrijft het zoals je het hoort)", "kadoo (de klank is lang, dus dubbele 'oo')", "cadoo (begint met 'c' maar eindigt op '-oo')"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Franse leenwoorden",
            "content": "Franse leenwoorden behouden hun Franse spelling: cadeau (met -eau). Dit moet je uit je hoofd leren. Andere voorbeelden: bureau, niveau, plateau.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "loanword_french_eau",
      "variantIndex": 1,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De taalcoach verbetert 'kado' naar 'cadeau'. Dit is een Frans leenwoord dat zijn oorspronkelijke Franse spelling behoudt. De uitgang '-eau' klinkt als 'oo', maar wordt geschreven als '-eau'. Je kunt dit niet afleiden uit de klank — je moet de spelling uit je hoofd leren. Vergelijk met andere Franse leenwoorden: bureau, niveau, plateau. Allemaal met '-eau'.",
        "solutionSteps": [
          "Herken dat 'kado' een leenwoord is — het klinkt niet-Nederlands",
          "Bepaal de oorsprong: 'cadeau' komt uit het Frans",
          "Pas de regel toe: Franse leenwoorden behouden hun oorspronkelijke spelling",
          "De Franse spelling is 'cadeau' (met c- en -eau), niet de fonetische spelling 'kado'"
        ],
        "distractorExplanations": {
          "0": "Correct! 'Cadeau' is een Frans leenwoord. De taalcoach weet: Franse leenwoorden behouden hun oorspronkelijke spelling met '-eau'.",
          "1": "Je dacht waarschijnlijk dat je het woord schrijft zoals je het hoort. Maar bij Franse leenwoorden geldt die regel niet — ze behouden hun oorspronkelijke spelling. 'Kado' is fonetisch Nederlands, maar de correcte spelling is 'cadeau'. Onthoud: bij leenwoorden moet je de oorspronkelijke spelling leren.",
          "2": "Je dacht waarschijnlijk dat de lange 'oo'-klank met dubbele 'oo' geschreven wordt. Maar de Franse uitgang '-eau' klinkt als 'oo' maar wordt anders geschreven. 'Kadoo' bestaat niet. Onthoud: de uitgang '-eau' is typisch Frans — bureau, niveau, plateau.",
          "3": "Je herkende terecht dat het woord met 'c' begint (Frans!), maar de uitgang is '-eau', niet '-oo'. De volledige Franse spelling is 'cadeau'. Onthoud: als je weet dat een woord Frans is, behoud dan de hele oorspronkelijke spelling."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.leen-fonetisch-schrijven", "label": "Schrijft leenwoord fonetisch (kado)", "optionIndex": 1 },
          { "id": "spr.leen-dubbele-klinker", "label": "Verdubbelt klinker voor lange klank (kadoo)", "optionIndex": 2 },
          { "id": "spr.leen-half-frans", "label": "Herkent begin maar niet uitgang (cadoo)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-LEEN-FRANS-002",
      "familyId": "SPR-LEEN-FRANS",
      "module": "SpellingRegel",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_frans",
      "questionType": "multiple_choice",
      "question": "Een journalist schrijft een artikel over een nieuw gebouw. Ze twijfelt over de spelling van het woord voor de stoep naast de weg. Welke spelling is correct?",
      "context": "Het woord klinkt als 'trot-twar'. De journalist weet dat het uit het Frans komt.",
      "options": ["trottoar", "trotwar", "trottoir", "trottuar"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Franse '-oir' uitgang",
            "content": "Het Franse woord 'trottoir' behoudt de oorspronkelijke spelling met '-oir'. De klank 'war' wordt in het Frans geschreven als '-oir'. Andere voorbeelden: reservoir, repertoire.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "loanword_french_oir",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De correcte spelling is 'trottoir'. Dit is een Frans leenwoord met de typische uitgang '-oir'. In het Frans klinkt '-oir' als 'war', maar de spelling blijft '-oir'. Let ook op de dubbele 't' in het midden. Vergelijk met andere Franse woorden op '-oir': reservoir, repertoire. Onthoud: de klank 'war' aan het eind van een Frans woord schrijf je als '-oir'.",
        "solutionSteps": [
          "Herken dat het woord Frans is (de klank 'war' is typisch Frans)",
          "Pas de regel toe: Franse '-oir' uitgang behoudt de oorspronkelijke spelling",
          "Let op de dubbele 't': trot-toir",
          "Controleer: trottoir — klopt met de Franse spelling"
        ],
        "distractorExplanations": {
          "0": "Je schreef de klank 'war' als '-oar'. Maar de Franse uitgang is '-oir', niet '-oar'. Onthoud: bij Franse leenwoorden schrijf je de 'war'-klank als '-oir' — trottoir, reservoir, repertoire.",
          "1": "Je schreef het woord zoals je het hoort: 'trotwar'. Maar bij Franse leenwoorden behoud je de oorspronkelijke spelling. De Franse uitgang '-oir' klinkt als 'war' maar wordt anders geschreven. Onthoud: trottoir met '-oir'.",
          "2": "Correct! 'Trottoir' is een Frans leenwoord. De uitgang '-oir' klinkt als 'war' maar behoudt de Franse spelling.",
          "3": "Je herkende de dubbele 't', maar de uitgang '-uar' bestaat niet in het Frans. De correcte Franse uitgang is '-oir'. Onthoud: de klank 'war' schrijf je bij Franse woorden als '-oir'."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.leen-oir-als-oar", "label": "Schrijft -oir als -oar", "optionIndex": 0 },
          { "id": "spr.leen-fonetisch-trotwar", "label": "Schrijft trottoir fonetisch (trotwar)", "optionIndex": 1 },
          { "id": "spr.leen-verkeerde-uitgang-uar", "label": "Verzint uitgang -uar", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-LEEN-FRANS-003",
      "familyId": "SPR-LEEN-FRANS",
      "module": "SpellingRegel",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_frans",
      "questionType": "multiple_choice",
      "question": "Een redacteur leest een menukaart na. Er staat: 'Welkom in ons restourant.' Ze ziet een spelfout. Welke spelling is correct?",
      "context": "Het woord voor een eetgelegenheid komt uit het Frans.",
      "options": ["restourant", "restaurant", "restaurand", "restarant"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Franse '-au-' en '-ant' spelling",
            "content": "Het woord 'restaurant' komt uit het Frans. Let op twee lastige plekken: de '-au-' in het midden (niet '-ou-') en de uitgang '-ant' (niet '-and'). In het Frans schrijf je nooit '-and' aan het eind.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "loanword_french_au_ant",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De correcte spelling is 'restaurant'. Dit Franse leenwoord heeft twee lastige plekken: de '-au-' in het midden (klinkt als 'o', maar schrijf je als 'au') en de uitgang '-ant' (niet '-and'). In het Frans eindigen woorden nooit op '-d'. Onthoud: rest-au-rant — de 'au' klinkt als 'o' maar is Frans, en het eindigt op '-ant'.",
        "solutionSteps": [
          "Herken dat 'restaurant' een Frans leenwoord is",
          "De klank 'o' in het midden schrijf je als '-au-' (Frans)",
          "De uitgang is '-ant', niet '-and' (Frans woord, geen -d)",
          "Controleer: rest-au-rant — klopt!"
        ],
        "distractorExplanations": {
          "0": "Je schreef 'restourant' met '-ou-'. Maar de Franse klank wordt geschreven als '-au-', niet '-ou-'. Vergelijk: 'auto' heeft ook '-au-' voor de 'o'-klank. Onthoud: rest-AU-rant.",
          "1": "Correct! 'Restaurant' met '-au-' en '-ant'. De Franse spelling is behouden.",
          "2": "Je schreef 'restaurand' met '-d' aan het eind. Maar Franse woorden eindigen niet op '-d'. De correcte uitgang is '-ant'. Onthoud: restaurant eindigt op '-ant', net als andere Franse woorden zoals 'elegant' en 'dominant'.",
          "3": "Je liet de '-au-' in het midden weg: 'restarant'. Maar het woord heeft drie lettergrepen: rest-au-rant. De '-au-' is essentieel — zonder die letters klopt het woord niet. Onthoud: rest-AU-rant."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.leen-au-als-ou", "label": "Schrijft -au- als -ou- (restourant)", "optionIndex": 0 },
          { "id": "spr.leen-ant-als-and", "label": "Schrijft -ant als -and (restaurand)", "optionIndex": 2 },
          { "id": "spr.leen-au-weggelaten", "label": "Laat -au- weg (restarant)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-LEEN-FRANS-004",
      "familyId": "SPR-LEEN-FRANS",
      "module": "SpellingRegel",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_frans",
      "questionType": "multiple_choice",
      "question": "Een vertaler werkt aan een tekst over wonen. Ze leest: 'De auto staat in de garasje.' Welke spelling van het onderstreepte woord is correct?",
      "context": "Het woord voor een berging voor auto's komt uit het Frans.",
      "options": ["garasje", "garaazje", "garrage", "garage"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Franse '-age' uitgang",
            "content": "Het woord 'garage' komt uit het Frans. De uitgang '-age' klinkt als 'aazje', maar wordt geschreven als '-age'. Andere voorbeelden: bagage, massage, etage. Onthoud: de 'zje'-klank aan het eind schrijf je bij Franse woorden als '-ge'.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "loanword_french_age",
      "variantIndex": 4,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "De correcte spelling is 'garage'. Dit is een Frans leenwoord met de uitgang '-age'. In het Frans klinkt '-age' als 'aazje', maar de spelling blijft '-age'. Vergelijk met andere Franse woorden: bagage, massage, etage, sabotage. Onthoud: de 'zje'-klank aan het eind van een Frans woord schrijf je als '-ge'.",
        "solutionSteps": [
          "Herken dat 'garage' een Frans leenwoord is",
          "De 'zje'-klank aan het eind is de Franse uitgang '-age'",
          "Schrijf: ga-ra-ge (niet 'garasje' of 'garaazje')",
          "Controleer: garage — klopt met de Franse spelling"
        ],
        "distractorExplanations": {
          "0": "Je schreef de klank 'zje' als '-sje'. Maar bij Franse leenwoorden schrijf je die klank als '-ge'. 'Garasje' is de fonetische Nederlandse spelling, maar de correcte spelling is 'garage'. Onthoud: -age = 'aazje' bij Franse woorden.",
          "1": "Je probeerde de lange 'aa'-klank en de 'zje'-klank apart te schrijven. Maar de Franse uitgang '-age' bevat beide klanken al. 'Garaazje' bestaat niet. Onthoud: garage — de '-age' doet al het werk.",
          "2": "Je verdubbelde de 'r': 'garrage'. Maar in het Frans is er maar één 'r' in 'garage'. Onthoud: ga-ra-ge — elke lettergreep heeft maar één medeklinker.",
          "3": "Correct! 'Garage' met de Franse uitgang '-age'. De 'zje'-klank schrijf je als '-ge'."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.leen-age-als-asje", "label": "Schrijft -age als -asje (garasje)", "optionIndex": 0 },
          { "id": "spr.leen-age-als-aazje", "label": "Schrijft -age als -aazje (garaazje)", "optionIndex": 1 },
          { "id": "spr.leen-dubbele-r", "label": "Verdubbelt r (garrage)", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "SPR-LEEN-FRANS-005",
      "familyId": "SPR-LEEN-FRANS",
      "module": "SpellingRegel",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_frans",
      "questionType": "multiple_choice",
      "question": "Een corrector controleert een reisbrochure. Er staat: 'Het hotel heeft een prachtig balkon met uitzicht op de boulevard.' Welk woord in deze zin is een Frans leenwoord dat zijn oorspronkelijke spelling heeft behouden?",
      "context": "Sommige woorden in het Nederlands komen uit het Frans en hebben een bijzondere spelling.",
      "options": ["balkon (oorspronkelijk Italiaans)", "boulevard (Frans: brede laan)", "hotel (oorspronkelijk Latijn)", "uitzicht (Nederlands woord)"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Franse leenwoorden herkennen",
            "content": "Een Frans leenwoord herken je vaak aan bijzondere lettercombinaties: '-eau' (cadeau), '-oir' (trottoir), '-ou-' (boulevard), '-age' (garage). 'Boulevard' heeft de typisch Franse '-ou-' spelling. Het woord klinkt als 'boelevaar'.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "loanword_french_herkennen",
      "variantIndex": 5,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Het Franse leenwoord is 'boulevard'. Je herkent het aan de typisch Franse lettercombinatie '-ou-' (klinkt als 'oe') en de uitgang '-ard'. In het Frans betekent het 'brede laan'. 'Balkon' komt oorspronkelijk uit het Italiaans (balcone), 'hotel' uit het Latijn (hospitale), en 'uitzicht' is een Nederlands woord. Onthoud: Franse leenwoorden hebben vaak bijzondere lettercombinaties die je niet verwacht op basis van de klank.",
        "solutionSteps": [
          "Bekijk elk woord: welke heeft een bijzondere spelling?",
          "'Boulevard' heeft '-ou-' (klinkt als 'oe') — typisch Frans",
          "Controleer de andere woorden: balkon (Italiaans), hotel (Latijn), uitzicht (Nederlands)",
          "Conclusie: 'boulevard' is het Franse leenwoord"
        ],
        "distractorExplanations": {
          "0": "Je dacht aan 'balkon', maar dat woord komt oorspronkelijk uit het Italiaans (balcone). Het is via het Frans in het Nederlands gekomen, maar de spelling is aangepast. 'Boulevard' heeft wél de oorspronkelijke Franse spelling behouden met '-ou-'.",
          "1": "Correct! 'Boulevard' is een Frans leenwoord. De '-ou-' spelling (klinkt als 'oe') is typisch Frans.",
          "2": "Je dacht aan 'hotel', maar dat woord komt uit het Latijn (hospitale). Het is via het Frans in het Nederlands gekomen, maar de spelling is sterk vereenvoudigd. 'Boulevard' heeft de typisch Franse '-ou-' spelling behouden.",
          "3": "Je dacht aan 'uitzicht', maar dat is een puur Nederlands woord (uit + zicht). Het is geen leenwoord. 'Boulevard' is het Franse leenwoord in deze zin, herkenbaar aan de '-ou-' spelling."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "spr.leen-balkon-als-frans", "label": "Denkt balkon is Frans (is Italiaans)", "optionIndex": 0 },
          { "id": "spr.leen-hotel-als-frans", "label": "Denkt hotel is Frans (is Latijn)", "optionIndex": 2 },
          { "id": "spr.leen-uitzicht-als-leen", "label": "Denkt uitzicht is leenwoord (is Nederlands)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-LEEN-FRANS-006",
      "familyId": "SPR-LEEN-FRANS",
      "module": "SpellingRegel",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_frans",
      "questionType": "multiple_choice",
      "question": "Een tekstschrijver maakt een brochure voor een zwembad. Ze schrijft: 'Neem je eigen handdoek en parasol mee naar het terras.' Welk woord is GEEN leenwoord?",
      "context": "In deze zin staan meerdere leenwoorden uit het Frans. Eén woord is puur Nederlands.",
      "options": ["parasol (Frans, van 'para' + 'sol')", "terras (Frans, van 'terrasse')", "handdoek (Nederlands samengesteld woord)", "brochure (Frans, van 'brocher')"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Leenwoorden vs. Nederlandse woorden",
            "content": "Een samengesteld woord als 'handdoek' (hand + doek) is puur Nederlands. 'Parasol' (para = tegen, sol = zon), 'terras' (terrasse) en 'brochure' (brocher) komen allemaal uit het Frans. Tip: als je een woord kunt splitsen in twee bekende Nederlandse woorden, is het waarschijnlijk geen leenwoord.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "loanword_french_onderscheiden",
      "variantIndex": 6,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "'Handdoek' is GEEN leenwoord — het is een Nederlands samengesteld woord (hand + doek). 'Parasol' komt uit het Frans (para = tegen, sol = zon), 'terras' komt uit het Frans (terrasse), en 'brochure' komt uit het Frans (brocher = naaien/stikken). Je herkent Nederlandse samenstellingen doordat je ze kunt splitsen in twee bekende Nederlandse woorden. Onthoud: niet elk 'moeilijk' woord is een leenwoord!",
        "solutionSteps": [
          "Bekijk elk woord: kun je het splitsen in Nederlandse delen?",
          "'Handdoek' = hand + doek — twee Nederlandse woorden → geen leenwoord",
          "'Parasol' en 'terras' hebben Franse oorsprong (para+sol, terrasse)",
          "'Brochure' komt uit het Frans (brocher = naaien/stikken)",
          "Conclusie: 'handdoek' is het enige puur Nederlandse woord"
        ],
        "distractorExplanations": {
          "0": "Je dacht dat 'parasol' geen leenwoord is. Maar 'parasol' komt uit het Frans: 'para' (tegen) + 'sol' (zon) = bescherming tegen de zon. De spelling met '-sol' is typisch Frans. 'Handdoek' daarentegen is puur Nederlands: hand + doek.",
          "1": "Je dacht dat 'terras' geen leenwoord is. Maar 'terras' komt van het Franse 'terrasse'. De dubbele 'r' en de uitgang '-as' wijzen op Franse oorsprong. 'Handdoek' is het Nederlandse woord in deze zin.",
          "2": "Correct! 'Handdoek' is een Nederlandse samenstelling (hand + doek). Geen leenwoord.",
          "3": "Je dacht dat 'brochure' geen leenwoord is. Maar 'brochure' komt uit het Frans (van 'brocher' = naaien/stikken). De uitgang '-ure' is typisch Frans. 'Handdoek' is het enige puur Nederlandse woord — een samenstelling van hand + doek."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "spr.leen-parasol-als-nl", "label": "Denkt parasol is Nederlands (is Frans)", "optionIndex": 0 },
          { "id": "spr.leen-terras-als-nl", "label": "Denkt terras is Nederlands (is Frans)", "optionIndex": 1 },
          { "id": "spr.leen-brochure-als-nl", "label": "Denkt brochure is Nederlands (is Frans)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-LEEN-FRANS-007",
      "familyId": "SPR-LEEN-FRANS",
      "module": "SpellingRegel",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_frans",
      "questionType": "matching",
      "question": "Koppel elk Frans leenwoord aan zijn oorspronkelijke Franse betekenis.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {"left": "cadeau", "right": "geschenk (Frans: cadeau)"},
          {"left": "trottoir", "right": "stoep (Frans: trottoir)"},
          {"left": "bureau", "right": "schrijftafel (Frans: bureau)"},
          {"left": "paraplu", "right": "tegen regen (Frans: parapluie)"}
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Franse leenwoorden herkennen",
            "content": "Franse leenwoorden herken je aan typische uitgangen: -eau (cadeau, bureau), -oir (trottoir, reservoir), -plu (paraplu van parapluie). Ze behouden (deels) hun Franse spelling.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "loanword_french_matching_origin",
      "variantIndex": 7,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Cadeau = geschenk, trottoir = stoep, bureau = schrijftafel, paraplu = tegen regen (para = tegen, pluie = regen). Al deze woorden komen uit het Frans en hebben hun oorspronkelijke spelling (deels) behouden.",
        "solutionSteps": [
          "Cadeau → geschenk (Frans: cadeau)",
          "Trottoir → stoep (Frans: trottoir, van 'trotter' = stappen)",
          "Bureau → schrijftafel (Frans: bureau)",
          "Paraplu → tegen regen (Frans: parapluie, para = tegen, pluie = regen)"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-LEEN-FRANS-008",
      "familyId": "SPR-LEEN-FRANS",
      "module": "SpellingRegel",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_frans",
      "questionType": "categorize",
      "question": "Sorteer deze woorden: welke zijn Franse leenwoorden en welke zijn Nederlandse woorden?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Frans leenwoord", "Nederlands woord"],
        "items": [
          {"text": "cadeau", "correctCategory": 0},
          {"text": "fiets", "correctCategory": 1},
          {"text": "bureau", "correctCategory": 0},
          {"text": "handdoek", "correctCategory": 1},
          {"text": "trottoir", "correctCategory": 0},
          {"text": "boekenkast", "correctCategory": 1}
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoe herken je een leenwoord?",
            "content": "Franse leenwoorden herken je aan ongewone spellingen: -eau (cadeau, bureau), -oir (trottoir). Nederlandse woorden kun je vaak splitsen in bekende delen: hand+doek, boeken+kast. Als het woord 'vreemd' klinkt of een ongewone spelling heeft, is het waarschijnlijk een leenwoord.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "loanword_french_categorize",
      "variantIndex": 8,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Franse leenwoorden: cadeau (-eau uitgang), bureau (-eau uitgang), trottoir (-oir uitgang). Nederlandse woorden: fiets (puur Nederlands), handdoek (samenstelling: hand + doek), boekenkast (samenstelling: boeken + kast). Tip: Nederlandse samenstellingen kun je splitsen in twee bekende woorden.",
        "solutionSteps": [
          "Cadeau → -eau uitgang = Frans leenwoord",
          "Fiets → geen vreemde spelling = Nederlands",
          "Bureau → -eau uitgang = Frans leenwoord",
          "Handdoek → hand + doek = Nederlandse samenstelling",
          "Trottoir → -oir uitgang = Frans leenwoord",
          "Boekenkast → boeken + kast = Nederlandse samenstelling"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    }
  ]
}